export default [
  {
    path: '/pdf',
    name: 'Pdf',
    component: (resolve) => require(['@/views/pdf/index'], resolve)
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/pdf.js